/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

/**
 * Enum to be used with :
 * - `gbc.StoredSettingsService.readGbcSettings(key)`
 * - `gbc.StoredSettingsService.writeGbcSettings(key, value)`
 * @readonly
 * @enum {string};
 */
gbc.constants.storedSettingKeys = {
  browserDefaultLocale: "browserDefaultLocale",
  sidebarVisible: "sidebarVisible",
  sidebarWidth: "sidebarWidth",
  sidebarDrawerDocked: "sidebarDrawerDocked",
  floatingPanelDocked: "floatingPanelDocked",
  aiMode: "aiMode",
  aiApiKey: "aiApiKey",
  accessibilityMode: "accessibilityMode"
};
